import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "app/store";
import { StoreDocumentStatus, StoreDocumentType } from "shared/models/models";

export const getCurrentDateString = () => new Date(Date.now()).toISOString();

// Define a type for the slice state
interface StoreState {
  date: string;
  type?: StoreDocumentType;
  statusId?: StoreDocumentStatus;
  addressId?: number;
}

// Define the initial state using that type
const initialState: StoreState = {
  date: new Date().toISOString(),
  type: undefined,
  statusId: undefined,
  addressId: 0,
};

export const storeSlice = createSlice({
  name: "store",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    setDate: (state, action: PayloadAction<string>) => {
      state.date = action.payload;
    },
    setType: (state, action: PayloadAction<StoreDocumentType | undefined>) => {
      state.type = action.payload;
    },
    setStatus: (
      state,
      action: PayloadAction<StoreDocumentStatus | undefined>,
    ) => {
      state.statusId = action.payload;
    },
    setAddress: (state, action: PayloadAction<number>) => {
      state.addressId = action.payload;
    },
  },
});

export const { setDate, setType, setStatus, setAddress } = storeSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const getDate = (state: RootState) => state.store.date;
export const getType = (state: RootState) => state.store.type;
export const getStatus = (state: RootState) => state.store.statusId;
export const getAddress = (state: RootState) => state.store.addressId;

export default storeSlice.reducer;
